<template>
  <div class="simulation-title-container">
    <Support/>
    <div class="simulation-title mt-4 pt-2">
      <div class="panel-title center">
        <div class="header-text" v-on:click="reload">
          Sense Experience
        </div>
      </div>
      <div class="sub-title center">
        <div class="header-text" v-on:click="reload">
          Virtual Reality
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Support from "./Support";

export default {
  name: 'SimulationView',
  components: {Support},
  methods: {
    reload() {
      location.reload();
    }
  }
}
</script>

<style scoped>
.simulation-title-container {
  display: flex;
  flex-direction: column;
  height: 65vh;
}

.panel-title {
  font-family: "Gotham Book", sans-serif;
  justify-content: center;
  font-size: 30px;
  width: auto;
}

.sub-title {
  font-family: "Gotham Book", sans-serif;
  justify-content: center;
  font-size: 12px;
}

.support {
  font-family: "Gotham Book", sans-serif;
  display: flex;
  align-self: flex-end;
  margin-right: 30px;
  margin-top: -60px;
  cursor: pointer;
}

.header-text {
  width: fit-content;
  cursor: pointer;
}

.center {
  display: flex;
  justify-content: center;
}

.simulation-title {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
}
</style>